import type { CommandPaletteDirectedSearchKind } from 'types/commandPaletteDirectedSearch';

const DIRECTED_SEARCH_KIND_LABEL_KEYS: Partial<
  Record<CommandPaletteDirectedSearchKind, string>
> = {
  customer: 'commandPalette.directed.kindCustomer',
  supplier: 'commandPalette.directed.kindSupplier',
  company_user: 'commandPalette.directed.kindCompanyUser',
  general_ledger_account: 'commandPalette.directed.kindAccount',
  customer_list: 'commandPalette.directed.kindCustomersList',
  supplier_list: 'commandPalette.directed.kindSuppliersList',
};

export function getCommandPaletteDirectedSearchKindLabelKey(
  kind: CommandPaletteDirectedSearchKind,
): string | null {
  return DIRECTED_SEARCH_KIND_LABEL_KEYS[kind] ?? null;
}
